import { ApiError } from 'shared/errors/ApiError';

/**
 * @param {unknown} error
 * @returns {boolean}
 */
function isExpirationVarianceReceiveError(error) {
    if (error instanceof ApiError && error.data?.expDateError === true) {
        return true;
    }
    const message = error instanceof Error ? error.message : '';
    return /expiration variance/i.test(message);
}

export { isExpirationVarianceReceiveError };
